<template>
<div class="error-wrapper">
    <div class="error-header-menu">
        <slot name="header">
            <h1>{{$t('menu.landscape_error')}}</h1>
        </slot>
    </div>
</div>
</template>

<script>
export default {
    name: "LandscapeError",
    created() {},
    data() {
        return {};
    },
    props: {},
    methods: {},
};
</script>

<style>
.error-wrapper {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #FFBF84;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Omnes, sans-serif;
}

.error-header-menu {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.error-header-menu h1 {
    color: white;
    text-align: center;
    align-self: center;
    margin: 0 1rem;
}

@media only screen and (max-width: 480px) {
  .error-header-menu h1 {
    font-size: 1.2rem;
  }
}

@media only screen and (min-width: 480px) and (max-width: 550px) {
  .error-header-menu h1 {
    font-size: 1.4rem;
  }
}

@media only screen and (min-width: 550px) and (max-width: 630px){
  .error-header-menu h1 {
    font-size: 1.6rem;
  }
}

@media only screen and (min-width: 630px) and (max-width: 718px){
  .error-header-menu h1 {
    font-size: 1.8rem;
  }
}

@media only screen and (min-width: 718px) and (max-width: 806px) {
  .error-header-menu h1 {
    font-size: 2rem;
  }
}

@media only screen and (min-width: 806px) and (max-width: 1024px) {
  .error-header-menu h1 {
    font-size: 2.2rem;
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {
  .error-header-menu h1 {
    font-size: 2.4rem;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {
  .error-header-menu h1 {
    font-size: 2.6rem;
  }
}

@media only screen and (min-width: 1366px) and (max-width: 1540px){
  .error-header-menu h1 {
    font-size: 2.8rem;
  }
}

@media only screen and (min-width: 1540px) and (max-width: 1680px){
  .error-header-menu h1 {
    font-size: 3rem;
  }
}

@media only screen and (min-width: 1680px) and (max-width:2350px){
  .error-header-menu h1 {
    font-size: 3.2rem;
  }
}

@media only screen and (min-width: 2350px)  and (max-width: 2550px) {
  .error-header-menu h1 {
    font-size: 3.4rem;
  }
}

@media only screen and (min-width: 2550px) {
  .error-header-menu h1 {
    font-size: 6rem;
  }
}
</style>
